module.exports = __webpack_public_path__ + "ath_game_web/img/Discord_Logo.75f054ef.png";